import React, { useEffect, useState } from "react";
import checkCircle from "../../../assets/img/icons/check-circle.svg";
import halfCircleLoader from "../../../assets/img/half-circle-loader.svg";

const StepsCard = ({
  title,
  score,
  state,
  scoreClass,
  stepNumberClass,
  stepNumber,
  key,
  stepCompleted,
}) => {
  return (
    <>
      <div class="col pa-r-0 pointer d-inline-flex pb-3" key={key}>
        <span class={`steps-count-${state} ${stepNumberClass} text-white`}>
          {stepNumber}
        </span>

        <div
          class={`card iq-mb-2 card-${state} border-success header-risk-card`}
        >
          <div class="card-body text-primary card-body-small">
            <h6 class="card-title risk-card-title mb-1">{title}</h6>
            <h2 class={`card-number ${scoreClass} risk-card-score`}>{score}</h2>
          </div>
          {stepCompleted ? (
            <img className="card-icon" src={checkCircle} alt={title} />
          ) : (
            <img src={halfCircleLoader} className="card-loading-icon" />
          )}
        </div>
      </div>
    </>
  );
};

export default StepsCard;
